import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

// GraphQL query for fetching all providers
export const GET_CONFIGURATIONS_QUERY = gql`
  query {
  configurations {
      id
      key
      value
    }
  }
`;

export const UPDATE_CONFIGURATION_BY_ID_MUTATION = gql`
  mutation updateConfigurationById($id: Int!, $input: UpdateConfigurationInput!) {
    updateConfigurationById(id: $id, input: $input) {
      id
      key
      value
    }
  }
`;

// GetAllProviders service class
export class GetConfigurationsService {
    private static instance: GetConfigurationsService;

  private constructor() {}

  public static getInstance(): GetConfigurationsService {
    if (!GetConfigurationsService.instance) {
      GetConfigurationsService.instance = new GetConfigurationsService();
    }
    return GetConfigurationsService.instance;
  }

    // Fetch all providers
    async getConfigurations(): Promise<any> {
        try {
            const { data } = await apolloClient.query({
                query: GET_CONFIGURATIONS_QUERY,
                fetchPolicy: 'network-only',
            });
            return data.configurations;
        } catch (error: any) {
            console.error('Error fetching providers:', error);
            if (error.graphQLErrors) {
                error.graphQLErrors.forEach((err: any) => {
                    console.error('GraphQL Error:', err.message);
                    console.error('Locations:', err.locations);
                    console.error('Path:', err.path);
                });
            }
            if (error.networkError) {
                console.error('Network Error:', error.networkError);
            }
            throw error;
        }
    }

    // Update configuration by ID
    async updateConfigurationById(id: number, value: string): Promise<any> {
        try {
            const { data } = await apolloClient.mutate({
                mutation: UPDATE_CONFIGURATION_BY_ID_MUTATION,
                variables: {
                    id,
                    input: {
                        value
                    }
                },
                refetchQueries: [{ query: GET_CONFIGURATIONS_QUERY }],
                awaitRefetchQueries: true,
            });
            return data.updateConfigurationById;
        } catch (error: any) {
            console.error('Error updating configuration:', error);
            if (error.graphQLErrors) {
                error.graphQLErrors.forEach((err: any) => {
                    console.error('GraphQL Error:', err.message);
                    console.error('Locations:', err.locations);
                    console.error('Path:', err.path);
                });
            }
            if (error.networkError) {
                console.error('Network Error:', error.networkError);
            }
            throw error;
        }
    }
}

// Export singleton instance
export const getConfigurationsService = GetConfigurationsService.getInstance();

// Export convenience function
export async function getConfigurations(): Promise<any> {
    return getConfigurationsService.getConfigurations();
}
